import { render, staticRenderFns } from "./UICheckoutSubtitle.vue?vue&type=template&id=5eb27641"
import script from "./UICheckoutSubtitle.vue?vue&type=script&lang=ts"
export * from "./UICheckoutSubtitle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports